import {ClaimType} from "@/models/ClaimTypes/ClaimType";

export class InMemoryClaimTypeRepo {
    all() {
        return [
            new ClaimType(0, 'Ninguna'),
            new ClaimType(1, 'Riesgo intermedio'),
            new ClaimType(2, 'Muy rigurosa'),
        ]
    }

    /**
     * @param {Number} claimId
     * @return {ClaimType|null}
     */
    getByClaimId(claimId) {
        let claimTypes = this.all();
        let claimTypeFound = claimTypes.filter((c) => c.id === claimId)
        if(claimTypeFound.length > 0) {
            return claimTypeFound[0];
        }
        return null;
    }
}
